import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'calendars',
  initialState: { // initial state of calendar state
    items: {},
  },
  reducers: {
    update(state, action) { //save state
      action.payload.forEach((item) => state.items[item.id] = item);
    },
  },
});

export { actions as calendarsActions };
export { reducer as calendarsReducer };
